<div class="gap-lg flex flex-col">
  @for (form of interrelationsForm.controls; track $index; let idx = $index) {
    <app-interrelation-group
      [form]="form"
      [index]="idx"
      [phases]="phases()"
      [interrelations]="interrelations()"
      [referentiel]="referentiel()"
    />
  }
  <app-button-add-new (click)="ajouterInterrelation()" label="Ajouter une autre interrelation" />
</div>
